<template>
  <div> {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Utilitario Auditoria Proveedor'" :titulo="'Utilitario Auditoria Proveedor'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
      <tr>

        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">

              <v-card color="grey lighten-3">
                <div class="px-2 pb-2" style="border: 1px solid #000000">
                <!-- FILTROS DE BUSQUEDA -->
                  <v-form ref="formFactVenta" v-model="valid" lazy-validation @submit.prevent="">

                    <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                      <v-row class="pa-0 ma-0 py-0 my-0">


                        <v-col class="pa-0 ma-0 px-2 py-1 mt-1" cols="12" md="6" sm="6" >
                          <div style="border: 1px solid #000000;">
                            <v-radio-group v-model="UtilAuditoriaProveedor.opcionTipoReg" class="pt-0 mt-0 d-flex justify-center " dense  hide-details row v-on:change="changeOpcionTipoReg" @change="getRegProved">
                                 
                                  <v-radio :value="0" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">FAC. PROVEEDOR</strong></template>
                                  </v-radio>

                                  <v-radio :value="1" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">CHEQUE</strong></template>
                                  </v-radio>

                                  <v-radio :value="2" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">PAGO FAC.PRODROVEEDOR</strong></template>
                                  </v-radio>
                                  <v-radio :value="3" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">NOTA DÉBITO</strong></template>
                                  </v-radio>
                            </v-radio-group>
                          </div>
                      <!-- <v-row class="pa-0 ma-0 py-0 my-0" ></v-row> -->
                                   
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                            <!-------------------------------------------------- proveedor -->
                            <v-combobox
                                        autocomplete="off"
                                        dense
                                        outlined
                                        label="Proveedor:"
                                        :items="Rproveedor"
                                        item-text="nombre"
                                        v-model="UtilAuditoriaProveedor.proveedor"
                                        @blur="SelctCbProveedor"
                                        @focus="cargarProveedor"
                                        @keyup="CbFilProveedor"  
                                      >
                                    <template v-slot:prepend>
                                     <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                                    </template> 
                                                  
                                   <template slot="item" slot-scope="item">
                                    <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                                    <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                                   </template>

                                   <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                                    <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                                   </template>

                                   <template v-slot:append-outer>
                                      <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn :disabled="validarRecBalance(UtilAuditoriaProveedor)" @click.prevent="recalcularBalanceProveedor" v-on="on" color="blue lighten-1" fab x-small dark>
                                      <i style="font-size: 20px;" class="fa fa-history"></i>
                                      </v-btn>
                                    </template>
                                              <span>CALCULA BALANCE</span>
                                        </v-tooltip>
                                    </template> 
                                                  
                                                  
                            </v-combobox>
                        </v-col>


                        <v-col  class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field v-model.number="UtilAuditoriaProveedor.numsec" autocomplete="off" dense hide-details
                                        label="No.Registro:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="getRegProved" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col  class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                         <v-combobox autocomplete="off" class="fontSize11" dense outlined label="Documentos:" :items="RDocumento"
                          item-text="descripcion"  v-model="UtilAuditoriaProveedor.documento"
                          @blur="SelctCbDocumento" @focus="cargarDocumento" id="formdisabledInput" 
                             >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-book"></i>
                          </template>
                        </v-combobox>
                        </v-col>


                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                            <v-text-field
                              id="fecha-inicial"
                              v-model="UtilAuditoriaProveedor.fechaInicial"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Inicial"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurDesde"
                              @input="getRegProved"
                              v-on:input="resertPaginacion">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                         <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field
                              v-model="UtilAuditoriaProveedor.fechaFinal"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Final"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurHasta"
                              @input="getRegProved"
                              v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col v-if="false" class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field v-model="UtilAuditoriaProveedor.ncf" autocomplete="off" dense hide-details label="NCF"
                                        outlined style="font-size: 12px;" @blur="getRegProved">
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>

                        </v-col>

                        

                      </v-row>
                    </v-col>
                  </v-form>
                <!-- FIN FILTROS DE BUSQUEDA -->

                <!-- TABLA DE REGISTRO -->
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <div style="border: 1px solid #000000">
                      <!-- @click:row="datostabla" -->
                      <v-data-table
                          v-if="resertPagi == true"
                          id="facturas-table"
                          v-model="selected"
                          :footer-props="arrayPropiedases"
                          :headers="[
                            { text: 'REFERENCIA', sortable: false, value: 'refregistro', width: 250 , class: ['no-gutters black--text'] },
                            { text: 'FECHA', sortable: false, value: 'fecha', width: 150 , class: ['no-gutters black--text'] },
                            { text: 'PROVEEDOR', sortable: false, value: 'nombreProveedor', width: 'auto', class: ['no-gutters black--text'] },
                            { text: 'VALOR', sortable: false, value: 'valor', width: 'auto', class: ['no-gutters black--text'] },
                            { text: 'ESTADO', sortable: false, value: 'activoanulado', width: 'auto', class: ['no-gutters black--text'] },
                          //  valor-width: 129 , activoanulado-width: 80 
                       ]"
                          :items="listRegistro"
                          :items-per-page="paginator.itemsPerPage"
                          :search="search"
                          :server-items-length="TotalRegistros"
                          :show-select="true"
                          :single-select="true"
                          class="elevation-1 RowSelectColor TbSize13"
                          dense
                          item-key="indx"
                          @pagination="cargarPaginacion"
                          @item-selected="obtenerDatoSelect"
                          @click:row="datostabla"
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <!-- <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)">
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn> -->
                        </template>

                        <template v-slot:item.fecha="props">
                          <span style="font-size: 13px; display: none">
                            {{ (props.item.indx = `${listRegistro.indexOf(props.item)}-${props.item.refregistro}`) }}
                          </span>
                          <span style="font-size: 13px">{{ FormatoFecha(props.item.fecha)}}</span>
                        <!-- FormatoFecha(props.item.fecha) -->
                        </template>

                        <template v-slot:item.nombreProveedor="props">
                          <span style="font-size: 13px">{{ props.item.nombreProveedor}}</span>
                        </template>

                        <template v-slot:item.valor="props">
                          <span style="font-size: 13px">{{ currencyFormatter(props.item.valor)}}</span>
                        </template>
                        

                        <template v-slot:item.activoanulado="props">
                           <span v-if="props.item.activo==true" style="font-size: 13px"> <b class="green--text">ACTIVO</b></span>
                          <span v-if="props.item.activo==false" style="font-size: 13px"> <b class="red--text">ANULADO</b></span>
                        </template>
                      </v-data-table>
                    </div>
                    </v-col>
                 <!-- FIN TABLA DE REGISTRO -->
                </div>
              </v-card>
              <hr/>
              <!-- DETALLE CHEQUE -->
               <v-col v-if="listaDetalleCheque.length>0" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
               <v-card color="grey lighten-3" > 
                  <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <span :class="`pl-2 d-flex justify-start black--text`"><b>DETALLE CHEQUE Y TRANSFERENCIA</b></span>
                  </v-col>

                <v-lazy  v-model="isActive"
                  :options="{  threshold: .5 }"
                  min-height="300"
                  transition="fade-transition"
                >

                    <div class="px-2 pt-1 overflow-x-auto" style="border: 1px solid #000000; max-height:300px; height:300px; " >
                      <v-form v-model="valid" ref="formTabDetalleCheque" lazy-validation> 

              <!-- id, inf.Registro, fecha,NCF, V.Original, tasa, pendiente, Abono, Descuento,Ret.ITBIS ,Ret.ISR   -->
                        <v-data-table class="elevation-1" dense
                                        :headers="[
                                       { text: '#id', value: 'id',width:130,sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'ID.Reg', value: 'regDoc',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Inf.Registro', value: 'infreg',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Fecha', value: 'fecha',width:120,sortable:false, class: ['no-gutters black--text'] }, 
                                       { text: 'NCF', sortable: false, value: 'ncf', width:129, class: ['no-gutters black--text'] }, 
                                       { text: 'Original', sortable: false, value: 'valororiginal', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'tasa', sortable: false, value: 'tasa', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Pendiente', sortable: false, value: 'pendiente', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Abono', sortable: false, value: 'abono', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'Descuento', sortable: false, value: 'descuento', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ITBIS', sortable: false, value: 'retencion', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ISR', sortable: false, value: 'isr', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'ACCIÓN', value: 'action', width: '130', sortable: true, class: ['no-gutters black--text'] }
                                        ]"
                                        :items="listaDetalleCheque" :items-per-page="-1" item-key="indx">

                                        <!-- <template v-slot:item.action="{ item }">
                                          --<v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>--  
                                          <v-btn fab @click.prevent="delGasto(item)" x-small color="red darken-3">
                                            <i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn>
                                        </template>-->

                                         <template v-slot:item.action="{ item }">
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                            <v-btn   v-on="on" fab @click.prevent="notifEliminarChequeDetalle(item)" x-small color="red"><i
                                                style="font-size: 20px;" class="fa fa-trash"></i>
                                            </v-btn>

                                            </template>
                                            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                                              <span> Eliminar Registro.</span>
                                            </i>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.fecha="props">
                                          <span style="font-size:13px; display:none;">{{props.item.indx = listaDetalleCheque.indexOf(props.item)}}</span>
                                          <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;" >{{ FormatoFecha(props.item.gastos.nuevaFecha) }}</span>
                                          <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.facturasProveedores.nuevaFecha) }}</span>
                                          <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.notacreditoproveedores.nuevaFecha) }}</span>
                                       </template>

                                       <template v-slot:item.infreg="props">
                                        <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.documentocontable.nombrecorto}}-{{props.item.gastos.gastosPK.secuencia}}  </span>
                                        <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.documentoproveedor.nombrecorto}}-{{props.item.facturasProveedores.facturasProveedoresPK.codigo}}  </span>
                                        <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.documentoproveedor.nombrecorto}}-{{props.item.notacreditoproveedores.notacreditoproveedoresPK.codigo}}  </span>
                                      </template>

                                      <template v-slot:item.ncf="props">
                                        <span  v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.ncf}}  </span>
                                        <span  v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.ncf}}  </span>
                                        <span  v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.ncf}}  </span>
                                      </template>

                                      <template v-slot:item.valororiginal="props">
                                      <span style="font-size: 13px">{{ currencyFormatter(props.item.valororiginal)}}</span>
                                    </template>

                                     <template v-slot:item.abono="props">
                                      <span style="font-size: 13px">{{ currencyFormatter(props.item.abono)}}</span>
                                    </template>
                                    
                                    <template v-slot:item.tasa="props">
                                      <span style="font-size:13px;">{{currencyFormatter(mostrarTasa(props.item))}}  </span>
                                    </template>
                                    
                                    <template v-slot:item.pendiente="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.pendiente)}}  </span>
                                    </template>

                                    <template v-slot:item.descuento="props">
                                      <span style="font-size:13px;">{{props.item.porcientodescuento=="v"? "$ ":"% "}} {{currencyFormatter(props.item.descuento)}}  </span>
                                    </template>

                                    <template v-slot:item.retencion="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.retencion)}}  </span>
                                    </template>

                                    <template v-slot:item.isr="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.isr)}}  </span>
                                    </template>

                                </v-data-table>
                             </v-form>

                    </div>
              </v-lazy>

                  </v-card>
               </v-col>
              <!-- FN DETALLE CHEQUE -->

               <!-- DETALLE PAGO FACT.PROVEE -->
               <v-col v-if="listaDetallePagoFact.length>0" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
               <v-card color="grey lighten-3" > 
                  <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <span :class="`pl-2 d-flex justify-start black--text`"><b>DETALLE PAGO FACT.PROVEEDOR</b></span>
                  </v-col>

                <v-lazy  v-model="isActive"
                  :options="{  threshold: .5 }"
                  min-height="300"
                  transition="fade-transition"
                >

                    <div class="px-2 pt-1 overflow-x-auto" style="border: 1px solid #000000; max-height:300px; height:300px; " >
                      <v-form v-model="valid" ref="formTabDetalleFactPro" lazy-validation> 

              <!-- id, inf.Registro, fecha,NCF, V.Original, tasa, pendiente, Abono, Descuento,Ret.ITBIS ,Ret.ISR   -->
                        <v-data-table class="elevation-1" dense
                                        :headers="[
                                       { text: '#id', value: 'pagoproveedoresDetallePK.id',width:130,sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'ID.Reg', value: 'regDoc',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Inf.Registro', value: 'infreg',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Fecha', value: 'fecha',width:120,sortable:false, class: ['no-gutters black--text'] }, 
                                       { text: 'NCF', sortable: false, value: 'ncf', width:129, class: ['no-gutters black--text'] }, 
                                       { text: 'Valor', sortable: false, value: 'valororiginal', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'tasa', sortable: false, value: 'tasa', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Pendiente', sortable: false, value: 'pendiente', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Abono', sortable: false, value: 'abono', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'Descuento', sortable: false, value: 'descuento', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ITBIS', sortable: false, value: 'retencion', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ISR', sortable: false, value: 'isr', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'ACCIÓN', value: 'action', width: '130', sortable: true, class: ['no-gutters black--text'] }
                                        ]"
                                        :items="listaDetallePagoFact" :items-per-page="-1" item-key="indx">

                                        <!-- <template v-slot:item.action="{ item }">
                                          --<v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>--  
                                          <v-btn fab @click.prevent="delGasto(item)" x-small color="red darken-3">
                                            <i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn>
                                        </template>-->

                                         <template v-slot:item.action="{ item }">
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                            <v-btn   v-on="on" fab @click.prevent="notifEliminarPagoFacProDetalle(item)" x-small color="red"><i
                                                style="font-size: 20px;" class="fa fa-trash"></i>
                                            </v-btn>

                                            </template>
                                            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                                              <span> Eliminar Registro.</span>
                                            </i>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.fecha="props">
                                          <span style="font-size:13px; display:none;">{{props.item.indx = listaDetallePagoFact.indexOf(props.item)}}</span>
                                          <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;" >{{ FormatoFecha(props.item.gastos.nuevaFecha) }}</span>
                                          <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.facturasProveedores.nuevaFecha) }}</span>
                                          <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.notacreditoproveedores.nuevaFecha) }}</span>
                                       </template>

                                       <template v-slot:item.infreg="props">
                                        <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.documentocontable.nombrecorto}}-{{props.item.gastos.gastosPK.secuencia}}  </span>
                                        <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.documentoproveedor.nombrecorto}}-{{props.item.facturasProveedores.facturasProveedoresPK.codigo}}  </span>
                                        <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.documentoproveedor.nombrecorto}}-{{props.item.notacreditoproveedores.notacreditoproveedoresPK.codigo}}  </span>
                                      </template>

                                      <template v-slot:item.ncf="props">
                                        <span  v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.ncf}}  </span>
                                        <span  v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.ncf}}  </span>
                                        <span  v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.ncf}}  </span>
                                      </template>

                                    <template v-slot:item.valororiginal="props">
                                        <span  v-if="props.item.hasOwnProperty('gastos') && props.item.gastos!=null" style="font-size:13px;">{{props.item.gastos.valorneto}}  </span>
                                        <span  v-if="props.item.hasOwnProperty('facturasProveedores') && props.item.facturasProveedores!=null " style="font-size:13px;">{{props.item.facturasProveedores.total}}  </span>
                                        <span  v-if="props.item.hasOwnProperty('notacreditoproveedores') && props.item.notacreditoproveedores!=null" style="font-size:13px;">{{props.item.notacreditoproveedores.valor}}  </span>
                                    </template>

                                     <template v-slot:item.abono="props">
                                      <span style="font-size: 13px">{{ currencyFormatter(props.item.abono)}}</span>
                                    </template>
                                    
                                    <template v-slot:item.tasa="props">
                                      <span style="font-size:13px;">{{currencyFormatter(mostrarTasa(props.item))}}  </span>
                                    </template>
                                    
                                    <template v-slot:item.pendiente="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.pendiente)}}  </span>
                                    </template>

                                    <template v-slot:item.descuento="props">
                                      <span style="font-size:13px;"> $ {{currencyFormatter(props.item.valordescuento)}}  </span>
                                    </template>

                                    <template v-slot:item.retencion="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.retencion)}}  </span>
                                    </template>

                                    <template v-slot:item.isr="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.retenciontercero)}}  </span>
                                    </template>

                                </v-data-table>
                             </v-form>

                    </div>
              </v-lazy>

                  </v-card>
               </v-col>
              <!-- FN DETALLE PAGO FACT.PROVEE -->

              <!-- DETALLE NOTA DEBITO PROVEE -->
               <v-col v-if="listaNotaDebitoProve.length>0" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
               <v-card color="grey lighten-3" > 
                  <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <span :class="`pl-2 d-flex justify-start black--text`"><b>DETALLE NOTA DEBITO PROVEEDOR</b></span>
                  </v-col>

                <v-lazy  v-model="isActive"
                  :options="{  threshold: .5 }"
                  min-height="300"
                  transition="fade-transition"
                >

                    <div class="px-2 pt-1 overflow-x-auto" style="border: 1px solid #000000; max-height:300px; height:300px; " >
                      <v-form v-model="valid" ref="formTabDetalleFactPro" lazy-validation> 

              <!-- id, inf.Registro, fecha,NCF, V.Original, tasa, pendiente, Abono, Descuento,Ret.ITBIS ,Ret.ISR   -->
                        <v-data-table class="elevation-1" dense
                                        :headers="[
                                       { text: '#id', value: 'notadebitoproveedoresPK.codigo',width:130,sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'ID.Reg', value: 'regDoc',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Inf.Registro', value: 'infreg',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                                       { text: 'Fecha', value: 'fecha',width:120,sortable:false, class: ['no-gutters black--text'] }, 
                                       { text: 'NCF', sortable: false, value: 'ncf', width:129, class: ['no-gutters black--text'] }, 
                                       { text: 'Valor', sortable: false, value: 'valororiginal', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'tasa', sortable: false, value: 'tasa', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Pendiente', sortable: false, value: 'pendiente', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Abono', sortable: false, value: 'abono', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'Descuento', sortable: false, value: 'descuento', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ITBIS', sortable: false, value: 'retencion', width:'auto', width:105, class: ['no-gutters black--text'] },
                                       { text: 'Ret.ISR', sortable: false, value: 'isr', width:'auto', width:105,class: ['no-gutters black--text'] },
                                       { text: 'ACCIÓN', value: 'action', width: '130', sortable: true, class: ['no-gutters black--text'] }
                                        ]"
                                        :items="listaNotaDebitoProve" :items-per-page="-1" item-key="indx">

                                        <!-- <template v-slot:item.action="{ item }">
                                          --<v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>--  
                                          <v-btn fab @click.prevent="delGasto(item)" x-small color="red darken-3">
                                            <i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn>
                                        </template>-->

                                         <template v-slot:item.action="{ item }">
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                            <v-btn   v-on="on" fab @click.prevent="notifEliminarNotaDebitoProveedor(item)" x-small color="red"><i
                                                style="font-size: 20px;" class="fa fa-trash"></i>
                                            </v-btn>

                                            </template>
                                            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                                              <span> Eliminar Registro.</span>
                                            </i>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.fecha="props">
                                          <span style="font-size:13px; display:none;">{{props.item.indx = listaNotaDebitoProve.indexOf(props.item)}}</span>
                                          <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;" >{{ FormatoFecha(props.item.gastos.nuevaFecha) }}</span>
                                          <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.facturasProveedores.nuevaFecha) }}</span>
                                          <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;" >{{ FormatoFecha(props.item.notacreditoproveedores.nuevaFecha) }}</span>
                                       </template>

                                       <template v-slot:item.infreg="props">
                                        <span v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.documentocontable.nombrecorto}}-{{props.item.gastos.gastosPK.secuencia}}  </span>
                                        <span v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.documentoproveedor.nombrecorto}}-{{props.item.facturasProveedores.facturasProveedoresPK.codigo}}  </span>
                                        <span v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.documentoproveedor.nombrecorto}}-{{props.item.notacreditoproveedores.notacreditoproveedoresPK.codigo}}  </span>
                                      </template>

                                      <template v-slot:item.ncf="props">
                                        <span  v-if="props.item.gastos!=null && props.item.hasOwnProperty('gastos')" style="font-size:13px;">{{props.item.gastos.ncf}}  </span>
                                        <span  v-if="props.item.facturasProveedores!=null && props.item.hasOwnProperty('facturasProveedores')" style="font-size:13px;">{{props.item.facturasProveedores.ncf}}  </span>
                                        <span  v-if="props.item.notacreditoproveedores!=null && props.item.hasOwnProperty('notacreditoproveedores')" style="font-size:13px;">{{props.item.notacreditoproveedores.ncf}}  </span>
                                      </template>

                                    <template v-slot:item.valororiginal="props">
                                        <span  v-if="props.item.hasOwnProperty('gastos') && props.item.gastos!=null" style="font-size:13px;">{{props.item.gastos.valorneto}}  </span>
                                        <span  v-if="props.item.hasOwnProperty('facturasProveedores') && props.item.facturasProveedores!=null " style="font-size:13px;">{{props.item.facturasProveedores.total}}  </span>
                                        <span  v-if="props.item.hasOwnProperty('notacreditoproveedores') && props.item.notacreditoproveedores!=null" style="font-size:13px;">{{props.item.notacreditoproveedores.valor}}  </span>
                                    </template>

                                     <template v-slot:item.abono="props">
                                      <span style="font-size: 13px">{{ currencyFormatter(props.item.abono)}}</span>
                                    </template>
                                    
                                    <template v-slot:item.tasa="props">
                                      <span style="font-size:13px;">{{currencyFormatter(mostrarTasa(props.item))}}  </span>
                                    </template>
                                    
                                    <template v-slot:item.pendiente="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.pendiente)}}  </span>
                                    </template>

                                    <template v-slot:item.descuento="props">
                                      <span style="font-size:13px;"> $ {{currencyFormatter(props.item.valordescuento)}}  </span>
                                    </template>

                                    <template v-slot:item.retencion="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.retencion)}}  </span>
                                    </template>

                                    <template v-slot:item.isr="props">
                                      <span style="font-size:13px;">{{currencyFormatter(props.item.retenciontercero)}}  </span>
                                    </template>

                                </v-data-table>
                             </v-form>

                    </div>
              </v-lazy>

                  </v-card>
               </v-col>
              <!-- FN DETALLE NOTA DEBITO PROVEE -->

            </div>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->

        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            ">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br></br>
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

     <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsUtilitarioFacturaVentas ref="RefComponentsUtilitarioFacturaVentas"/>
    </div>

    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsUtilitarioDevolucion ref="RefComponentsUtilitarioDevolucion"/>
    </div>
  
    <!-- columna  ---------------------->
    <div class="overflow-x-auto" v-show="false">
                  <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
    </div>

<!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Notificaciones" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>


           <v-card-actions :class="`d-flex justify-center`">

          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEliminarChequeDetalle'"
            @click.prevent="eliminarChequeDetalle(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEliminarPagoFacProDetalle'"
            @click.prevent="eliminarPagoFacProDetalle(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEliminarNotaDebitoProv'"
            @click.prevent="eliminarNotaDebitoProveedor(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="red" 
          @click.prevent="cerrarNotificacion" large>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>

           </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->



    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import ContenidoBase from "../components/ContenidoBase"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter,fechaNueva } from "@/js/Funciones.js"
import { parse } from "@fortawesome/fontawesome-svg-core";
import ComponentsUtilitarioFacturaVentas from "@/Utilitario/UtilitarioFacturaVentas.vue"
import ComponentsUtilitarioDevolucion from "@/Utilitario/UtilitarioDevolucion.vue"
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ComponentsUtilitarioFacturaVentas,
    ComponentsUtilitarioDevolucion,
    PvDgiiFacturacionEletronica
  },

  created() {
    var json = {
      titulo: "Utilitario Auditoria Proveedor",
      descripcion: "Utilitario Auditoria Proveedor",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
      accion: [
        "UtilAuditoriaProveedorNew",
        "UtilAuditoriaProveedorSave",
        "UtilAuditoriaProveedorRemove",
        "UtilAuditoriaProveedorAnular",
        "UtilAuditoriaProveedorPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("UtilAuditoriaProveedorNew", this.new);
    // EventBus.$on("UtilAuditoriaProveedorSave", this.save);
    // EventBus.$on("UtilAuditoriaProveedorRemove", this.remove);
    // EventBus.$on("UtilAuditoriaProveedorAnular", this.remove);
    // EventBus.$on("UtilAuditoriaProveedorPrintList", this.imprimirList);
    EventBus.$on("emitUtilAuditoriaProveedor", this.datostabla)
    EventBus.$on("onResize", this.onResize)


//this.actualzarinfo_factura_dgi(dt)


    this.getRegProved()
  },

  data: () => ({
    isActive:false,
    arrayPropiedases: {
      "items-per-page-options": [10, 15, 20, 50],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
    },
    listDatos: [],
    selectedListFact: [],
    selected: [],
    RDocumento: [],
    Rproveedor:[],
    RDocumento:[],
    listRegistro:[],
    windowSize: { width: "auto", height: "auto" },
    texAria: "",
    rowDesTab: 25,
    Reparaloading: false,
    DtoRegistro:null,
    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    
    UtilAuditoriaProveedor: {
      ncf: null,
      opcion:0,
      numsec: null,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      opcionTipoReg:0,
      proveedor:null,
      documento:null
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },
    listaDetalleCheque:[],
    listaDetallePagoFact:[],
    listaNotaDebitoProve:[],

notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" },
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

    debounceTimer: null,
  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter, getParamFecha,fechaNueva,
    onResize(e) {
      //this.windowSize=e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },

    // datostabla(e) {
    //   this.UtilAuditoriaProveedor = e
    //   this.acti_tb_data = false
    // },

    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    newwnuevo() {
      (this.UtilAuditoriaProveedor = {
            ncf: null,
            opcion:0,
            numsec: null,
            fechaInicial: fechaNueva(),
            fechaFinal: fechaNueva(),
            opcionTipoReg:1,
            proveedor:null,
            documento:null
      }),
        EventBus.$emit("actualizaBarraBusqueda2")
    },

    resertPaginacion() {
      this.resertPagi = false

      this.paginator.page = 1
      this.paginator.pageStart = 0
      this.paginator.pageStop = this.paginator.itemsPerPage

      var _this = this
      setTimeout(function () {
        _this.resertPagi = true
      }, 500)

      //setTimeout(this.resertPagi=true,1500);
    },

    cargarPaginacion(e) {
      this.selected = []
      // console.log('cargarPaginacion')
      //     console.log(e);
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
        // this.paginator.itemsPerPage.push(15)
      }

      this.getRegProved()
      //   this.filtro();
    },

    changeOpcionTipoReg(){
          
        this.listaDetalleCheque=[]
        this.listaDetallePagoFact=[]
        this.listaNotaDebitoProve=[]
       // this.TotalRegistros
        //this.listRegistro
        this.selected=[]

    },

     getRegProved() {
      // if(this.UtilAuditoriaProveedor.NoFactura.length==0){this.UtilAuditoriaProveedor.NoFactura=0}

      if ((this.UtilAuditoriaProveedor.numsec != null && this.UtilAuditoriaProveedor.numsec.length == 0) ||
          this.UtilAuditoriaProveedor.numsec == 0){
        this.UtilAuditoriaProveedor.numsec = null
         }
      if (this.UtilAuditoriaProveedor.ncf != null && this.UtilAuditoriaProveedor.ncf.length == 0) {
        this.UtilAuditoriaProveedor.ncf = null
      }

      if (this.$refs.formFactVenta.validate()) {
 

        var obj = JSON.parse(JSON.stringify(this.UtilAuditoriaProveedor))
            obj.descProve=null;
            obj.codProve=null;
            obj.coddoc=null;
           var OBJ_DATA=null;
              
         
        if(obj.proveedor!=null && obj.proveedor.hasOwnProperty("nombre")){
            obj.descProve=obj.proveedor.nombre
        }

         if(obj.documento!=null && obj.documento.hasOwnProperty("codigo")){
            obj.coddoc=obj.documento.codigo
        }

  if(this.UtilAuditoriaProveedor.opcionTipoReg==0){

    OBJ_DATA={
             codigo:this.UtilAuditoriaProveedor.numsec==null?"null":this.UtilAuditoriaProveedor.numsec,
              doc:obj.coddoc!=null?obj.coddoc:"null",
              prov:obj.codProve!=null?obj.codProve:"null",
              desde: this.UtilAuditoriaProveedor.fechaInicial,
              hasta: this.UtilAuditoriaProveedor.fechaFinal,
              opcionTipoReg:this.UtilAuditoriaProveedor.opcionTipoReg,
              searchByCodigo:"true"
            }
  }






        if(this.UtilAuditoriaProveedor.opcionTipoReg==1){
          //ope:14

             OBJ_DATA={
              codigo:this.UtilAuditoriaProveedor.numsec==null?"null":this.UtilAuditoriaProveedor.numsec,
              coddoc:obj.coddoc!=null?obj.coddoc:"null",
              pro:obj.descProve!=null?obj.descProve:"null",
              ope:"null", cue:"null",
              desde: this.UtilAuditoriaProveedor.fechaInicial,
              hasta: this.UtilAuditoriaProveedor.fechaFinal,
              opcionTipoReg:this.UtilAuditoriaProveedor.opcionTipoReg
            }

        }

        if(this.UtilAuditoriaProveedor.opcionTipoReg==2){
          OBJ_DATA={
              codigo:this.UtilAuditoriaProveedor.numsec==null?"null":this.UtilAuditoriaProveedor.numsec,
              doc:obj.coddoc!=null?obj.coddoc:"null",
              prov:obj.codProve!=null?obj.codProve:"null",
              desde: this.UtilAuditoriaProveedor.fechaInicial,
              hasta: this.UtilAuditoriaProveedor.fechaFinal,
              opcionTipoReg:this.UtilAuditoriaProveedor.opcionTipoReg
            }
        }


        if(this.UtilAuditoriaProveedor.opcionTipoReg==3){
          
          OBJ_DATA={
              codigo:this.UtilAuditoriaProveedor.numsec==null?"null":this.UtilAuditoriaProveedor.numsec,
              doc:obj.coddoc!=null?obj.coddoc:"null",
              prov:obj.codProve!=null?obj.codProve:"null",
              desde: this.UtilAuditoriaProveedor.fechaInicial,
              hasta: this.UtilAuditoriaProveedor.fechaFinal,
              opcionTipoReg:this.UtilAuditoriaProveedor.opcionTipoReg
            }

        }


                OBJ_DATA.limit = this.paginator.itemsPerPage
               OBJ_DATA.ultimo = this.paginator.pageStart
    
        this.$axios.post(this.$hostname + this.$hName + "/UtilitarioAuditoriaProveedor/getRegProveedores", OBJ_DATA, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listRegistro = res.data.listRegistro)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },


    GetDataFact(e) {
      this.listDatos = []
      this.listDatos = e
    },

 
    obtenerDatoSelect(e) {
      this.datostabla(e.item)
    },

    datostabla(e) {
      this.listaDetalleCheque=[]
      this.listaDetallePagoFact=[]
      this.listaNotaDebitoProve=[]


        if(this.selected.length>0 && this.selected[0].indx===e.indx){
          this.selected= []
          this.DtoRegistro=null
          return
        }

      var eftc = JSON.parse(JSON.stringify(e))
       this.selected = []
      this.selected.push(eftc)
      this.DtoRegistro=eftc

     
     // this.selected.push(JSON.parse(JSON.stringify(e)))
      //this.DtoRegistro=JSON.parse(JSON.stringify(e))

      

   if(eftc.tiporegistro==="facturaProveedor"){
EventBus.$emit("loading", true);
      var OBJ_DATA={
              codsec:eftc.facturaProveedor.facturasProveedoresPK.codigo,
              coddoc:eftc.facturaProveedor.facturasProveedoresPK.documento
            }


       this.$axios.post(this.$hostname + this.$hName + "/UtilitarioAuditoriaProveedor/getRegAsociadoFacProve", OBJ_DATA, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              EventBus.$emit("loading", false);
              this.listaDetalleCheque=res.data.listCheque
              this.listaDetallePagoFact=res.data.listPagoProveedor
              this.listaNotaDebitoProve= res.data.listdebProveedor
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
              EventBus.$emit("loading", false);
            })

    
      }



      if(eftc.tiporegistro==="cheque"){
        if(eftc.cheque.chequesDetalleList.length>0){
          this.listaDetalleCheque=eftc.cheque.chequesDetalleList 
        }
      }


     if(eftc.tiporegistro==="pagoproveedores"){
        if(eftc.pagoproveedores.pagoproveedoresDetalleList.length>0){
          this.listaDetallePagoFact=eftc.pagoproveedores.pagoproveedoresDetalleList 
        }
      }

      if(eftc.tiporegistro==="notaDebproveedores"){
        this.listaNotaDebitoProve.push(eftc.notaDebitoProveedores)

        // if(eftc.notaDebproveedores.pagoproveedoresDetalleList.length>0){
        //   this.listaDetallePagoFact=eftc.pagoproveedores.pagoproveedoresDetalleList 
        // }

      }




    },

    ver(e) {
      var au = e.split("\n").length
      this.rowDesTab = (au + 2)
    },




 BlurDesde() {
      if (this.UtilAuditoriaProveedor.fechaInicial.toString().length == 0) {
        this.UtilAuditoriaProveedor.fechaInicial = this.fechaNueva()
      }
    },

 BlurHasta() {
      if (this.UtilAuditoriaProveedor.fechaFinal.toString().length == 0) {
        this.UtilAuditoriaProveedor.fechaFinal = this.fechaNueva()
      }
    },

cargarProveedor(){
this.$axios.get(this.$hostname+this.$hName+'/proveedores/findallbyDesc/25/0/*',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.Rproveedor=res.data))
},

CbFilProveedor(e) {
if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
              this.$hName +
              "/proveedores/findallbyDesc/25/0/"+(e.target.value===""?"*":e.target.value),
              {headers:this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.Rproveedor = res.data));
        }
    },


    SelctCbProveedor(){
var _this = this
      setTimeout(function() {
        if (_this.UtilAuditoriaProveedor.proveedor == null) {
          _this.UtilAuditoriaProveedor.proveedor = ""
        }

        if (!_this.UtilAuditoriaProveedor.proveedor.hasOwnProperty("codigo")) {
          _this.UtilAuditoriaProveedor.proveedor = ""
          _this.UtilAuditoriaProveedor.proveedor = null
          return
        }
      }, 300)

},



cargarDocumento() {

  // opcionTipoReg-> 1:CHEQUE, 2:PAGO FAC.PRODROVEEDOR, 3: NOTA DÉBITO
  if(this.UtilAuditoriaProveedor.opcionTipoReg==1){
          this.$axios.get(this.$hostname + this.$hName + "/documentobanco/documentocheques", {
                headers: this.$store.getters.GetheadersAxios, })
              .then((res) => {this.RDocumento = res.data })
  }

  if(this.UtilAuditoriaProveedor.opcionTipoReg==2){
    this.$axios.get(this.$hostname + this.$hName + '/documentoscxp/findAllDocumentosPagosProveedores', { headers: this.$store.getters.GetheadersAxios })
            .then(res => (this.RDocumento = res.data))
  }


  if(this.UtilAuditoriaProveedor.opcionTipoReg==3){

     this.$axios.get(this.$hostname + this.$hName + "/documentoscxp/findAllDocumentosNotaDebito", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumento = res.data))
  }


 
       

    },


 SelctCbDocumento() {
      var _this = this
      setTimeout(function() {
        if (_this.UtilAuditoriaProveedor.documento == null) {
          _this.UtilAuditoriaProveedor.documento = ""
        }

        if (!_this.UtilAuditoriaProveedor.documento.hasOwnProperty("codigo")) {
          _this.UtilAuditoriaProveedor.documento = ""
          _this.UtilAuditoriaProveedor.documento = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)
    },

    mostrarTasa(e){

if(e.hasOwnProperty('facturasProveedores')&& e.facturasProveedores!=null){
  return e.facturasProveedores.tasa
}

if(e.hasOwnProperty('notacreditoproveedores')&& e.notacreditoproveedores!=null){
  return e.notacreditoproveedores.tasa
}

  

},
    

notifEliminarChequeDetalle(notifConfAdicional){
  console.log('VIENDO-->',notifConfAdicional)
  var infReg='';
if(notifConfAdicional.hasOwnProperty('gastos') && notifConfAdicional.gastos!=null ){
  infReg= `${notifConfAdicional.gastos.documentocontable.nombrecorto.trim()}-${notifConfAdicional.gastos.gastosPK.secuencia}` 
}

if( notifConfAdicional.hasOwnProperty('facturasProveedores') && notifConfAdicional.facturasProveedores!=null ){
  infReg= `${notifConfAdicional.facturasProveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.facturasProveedores.facturasProveedoresPK.codigo}`
}

if(notifConfAdicional.hasOwnProperty('notacreditoproveedores') && notifConfAdicional.notacreditoproveedores!=null ){
infReg=`${notifConfAdicional.notacreditoproveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.notacreditoproveedores.notacreditoproveedoresPK.codigo}`
}


this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea eliminar este registro \n #ID:${ notifConfAdicional.id}.  Inf.Registro:${infReg}.?`,
      Exec: "contEliminarChequeDetalle",
      objTemp: notifConfAdicional,
    }
    return
      },

notifEliminarPagoFacProDetalle(notifConfAdicional){
  console.log('VIENDO-->',notifConfAdicional)
  var infReg='';
if(notifConfAdicional.hasOwnProperty('gastos') && notifConfAdicional.gastos!=null ){
  infReg= `${notifConfAdicional.gastos.documentocontable.nombrecorto.trim()}-${notifConfAdicional.gastos.gastosPK.secuencia}` 
}

if( notifConfAdicional.hasOwnProperty('facturasProveedores') && notifConfAdicional.facturasProveedores!=null ){
  infReg= `${notifConfAdicional.facturasProveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.facturasProveedores.facturasProveedoresPK.codigo}`
}

if(notifConfAdicional.hasOwnProperty('notacreditoproveedores') && notifConfAdicional.notacreditoproveedores!=null ){
infReg=`${notifConfAdicional.notacreditoproveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.notacreditoproveedores.notacreditoproveedoresPK.codigo}`
}


this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea eliminar este registro \n #ID:${ notifConfAdicional.pagoproveedoresDetallePK.id}.  Inf.Registro:${infReg}.?`,
      Exec: "contEliminarPagoFacProDetalle",
      objTemp: notifConfAdicional,
    }
    return
      },


notifEliminarNotaDebitoProveedor(notifConfAdicional){
  console.log('VIENDO-->',notifConfAdicional)
  var infReg='';
if(notifConfAdicional.hasOwnProperty('gastos') && notifConfAdicional.gastos!=null ){
  infReg= `${notifConfAdicional.gastos.documentocontable.nombrecorto.trim()}-${notifConfAdicional.gastos.gastosPK.secuencia}` 
}

if( notifConfAdicional.hasOwnProperty('facturasProveedores') && notifConfAdicional.facturasProveedores!=null ){
  infReg= `${notifConfAdicional.facturasProveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.facturasProveedores.facturasProveedoresPK.codigo}`
}

if(notifConfAdicional.hasOwnProperty('notacreditoproveedores') && notifConfAdicional.notacreditoproveedores!=null ){
infReg=`${notifConfAdicional.notacreditoproveedores.documentoproveedor.nombrecorto.trim()}-${notifConfAdicional.notacreditoproveedores.notacreditoproveedoresPK.codigo}`
}


this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea anular este registro \n #ID:${ notifConfAdicional.notadebitoproveedoresPK.codigo}.  Inf.Registro:${infReg}.?`,
      Exec: "contEliminarNotaDebitoProv",
      objTemp: notifConfAdicional,
    }
    return
      },



cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},


eliminarChequeDetalle(ITEM){
  
  var OBJ={
    id:ITEM.id,
  }


if( ITEM.hasOwnProperty('facturasProveedores') && ITEM.facturasProveedores!=null ){
  OBJ.opcTipo=1
  OBJ.codsec=ITEM.facturasProveedores.facturasProveedoresPK.codigo
  OBJ.coddoc=ITEM.facturasProveedores.facturasProveedoresPK.documento
}

if(ITEM.hasOwnProperty('notacreditoproveedores') && ITEM.notacreditoproveedores!=null ){
  OBJ.opcTipo=2
  OBJ.codsec=ITEM.notacreditoproveedores.notacreditoproveedoresPK.codigo
  OBJ.coddoc=ITEM.notacreditoproveedores.notacreditoproveedoresPK.documento
}

if(ITEM.hasOwnProperty('gastos') && ITEM.gastos!=null ){
  OBJ.opcTipo=3
  OBJ.codsec=ITEM.gastos.gastosPK.secuencia
  OBJ.coddoc=ITEM.gastos.gastosPK.documento
}


EventBus.$emit("loading", true);

this.$axios.post(this.$hostname + this.$hName + "/UtilitarioAuditoriaProveedor/eliminarChequeDetalle", OBJ,
              { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              
                 const index = this.listaDetalleCheque.indexOf(ITEM)
                    this.listaDetalleCheque.splice(index, 1)

                /* this.selected=[]
                this.UtilGastosMenores.gastosmenoresDetalleList=JSON.parse(JSON.stringify(GASTO_ME_LIST_FILTRADO))
                const index = this.UtilGastosMenores.gastoMenoresNcfList.indexOf(ITEM)
                this.UtilGastosMenores.gastoMenoresNcfList.splice(index, 1)*/

              EventBus.$emit("loading", false);
              this.alerta("DATO MODIFICADO (REVISE) ", "bien")
              this.cerrarNotificacion()


            })
            .catch(error =>{
              EventBus.$emit("loading", false);
              this.alerta("Dato no MODIFICADO", "error")
            });



},

eliminarPagoFacProDetalle(ITEM){



  var OBJ={
    id:ITEM.pagoproveedoresDetallePK.id,
    codsec:ITEM.pagoproveedoresDetallePK.secuencia,
    coddoc:ITEM.pagoproveedoresDetallePK.documento
  }


EventBus.$emit("loading", true);

this.$axios.post(this.$hostname + this.$hName + "/UtilitarioAuditoriaProveedor/eliminarPagoFacProveeDetalle", OBJ,
              { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              
                 const index = this.listaDetallePagoFact.indexOf(ITEM)
                    this.listaDetallePagoFact.splice(index, 1)

                /* this.selected=[]
                this.UtilGastosMenores.gastosmenoresDetalleList=JSON.parse(JSON.stringify(GASTO_ME_LIST_FILTRADO))
                const index = this.UtilGastosMenores.gastoMenoresNcfList.indexOf(ITEM)
                this.UtilGastosMenores.gastoMenoresNcfList.splice(index, 1)*/

              EventBus.$emit("loading", false);
              this.alerta("DATO MODIFICADO (REVISE) ", "bien")
              this.cerrarNotificacion()


            })
            .catch(error =>{
              EventBus.$emit("loading", false);
              this.alerta("Dato no MODIFICADO", "error")
            });



},


eliminarNotaDebitoProveedor(ITEM){


  var OBJ={
    codsec:ITEM.notadebitoproveedoresPK.codigo,
    coddoc:ITEM.notadebitoproveedoresPK.documento
  }


EventBus.$emit("loading", true);

this.$axios.post(this.$hostname + this.$hName + "/UtilitarioAuditoriaProveedor/borrarNotadebitoProveedor", OBJ,
              { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              
                 const index = this.listaNotaDebitoProve.indexOf(ITEM)
                    this.listaNotaDebitoProve.splice(index, 1)


              EventBus.$emit("loading", false);
              this.alerta("DATO MODIFICADO (REVISE) ", "bien")
              this.cerrarNotificacion()
              this.getRegProved()



            })
            .catch(error =>{
              EventBus.$emit("loading", false);
              this.alerta("Dato no MODIFICADO", "error")
            });



},

validarRecBalance(DATA){
var BOOL =true

if(DATA!=null && DATA.hasOwnProperty('proveedor') && DATA.proveedor!=null && DATA.proveedor.hasOwnProperty('codigo')){
  BOOL=false
}

  return BOOL;
},

 recalcularBalanceProveedor() {
      //this.Reparaloading = true
      EventBus.$emit("loading", true);

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          `/utilitarioFacturaProveedores/recalcularBalanceProveedor/${this.UtilAuditoriaProveedor.proveedor.codigo}/`,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          var _this = this
          setTimeout(function() {
          //  _this.Reparaloading = false
          EventBus.$emit("loading", false);
            _this.alertaNotf("Recalculo procesado ", "bien")
          }, 1000)
        })
        .catch((error) => {
         // this.Reparaloading = false
         EventBus.$emit("loading", false);
          this.alerta("Error durante recalculo", "error")
        })
    },




    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },
  },

  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    },
  },
}
</script>

<style></style>